<template>
  <div id="postnatal-app">
    <!-- Header with Mother & Baby Info -->
    <div class="header">
      <div class="patient-banner">
        <div class="patient-main-info">
          <h1 style="color: #fff">
            <i class="fas fa-baby"></i> Postnatal Clinic - Mother & Baby Care
          </h1>
          <div class="patient-id-section">
            <span class="patient-id">Mother ID: {{ mother.id }}</span>
            <span class="delivery-date">Delivery Date: {{ deliveryDate }}</span>
            <span class="postnatal-day">Day {{ postnatalDay }} Postpartum</span>
          </div>
        </div>
        <!-- <div class="action-buttons">
          <button class="btn btn-primary btn-lg" @click="editVisit">
            <i class="fas fa-edit"></i> Edit Visit
          </button>
          <button class="btn btn-success btn-lg" @click="scheduleFollowup">
            <i class="fas fa-calendar-plus"></i> Schedule Follow-up
          </button>
        </div> -->
      </div>

      <!-- Navigation Tabs -->
      <div class="navigation-tabs">
        <a
          href="/mch/pnc_treatment/"
          class="nav-btn"
          @click.prevent="activeTab = 'mother'"
          :class="{ active: activeTab === 'mother' }"
        >
          🪪 Client Identification
        </a>

        <a
          href="#"
          class="nav-btn"
          @click.prevent="activeTab = 'baby'"
          :class="{ active: activeTab === 'baby' }"
        >
          🤱 Maternal Assessment
        </a>

        <a
          href="#"
          class="nav-btn"
          @click.prevent="activeTab = 'breastfeeding'"
          :class="{ active: activeTab === 'breastfeeding' }"
        >
          👶 Newborn Assessment
        </a>

        <a
          href="#"
          class="nav-btn"
          @click.prevent="activeTab = 'contraception'"
          :class="{ active: activeTab === 'contraception' }"
        >
          💊 PNC Services Provided
        </a>

        <a
          href="#"
          class="nav-btn"
          @click.prevent="activeTab = 'complications'"
          :class="{ active: activeTab === 'complications' }"
        >
          🚑 Complications & Referrals
        </a>

        <a
          href="#"
          class="nav-btn"
          @click.prevent="activeTab = 'history'"
          :class="{ active: activeTab === 'history' }"
        >
          📅 PNC Completion
        </a>
      </div>

      <!-- <div class="navigation-tabs">
        <button
          class="nav-btn"
          @click="activeTab = 'mother'"
          :class="{ active: activeTab === 'mother' }"
        >
          <i class="fas fa-female"></i> Client Identification
        </button>
        <button
          class="nav-btn"
          @click="activeTab = 'baby'"
          :class="{ active: activeTab === 'baby' }"
        >
          <i class="fas fa-baby"></i> Maternal Assessment
        </button>
        <button
          class="nav-btn"
          @click="activeTab = 'breastfeeding'"
          :class="{ active: activeTab === 'breastfeeding' }"
        >
          <i class="fas fa-prescription-bottle"></i> Newborn Assessment
        </button>
        <button
          class="nav-btn"
          @click="activeTab = 'contraception'"
          :class="{ active: activeTab === 'contraception' }"
        >
          <i class="fas fa-shield-alt"></i> PNC Services Provided
        </button>
        <button
          class="nav-btn"
          @click="activeTab = 'complications'"
          :class="{ active: activeTab === 'complications' }"
        >
          <i class="fas fa-exclamation-triangle"></i> Complications & Referrals
        </button>
        <button
          class="nav-btn"
          @click="activeTab = 'history'"
          :class="{ active: activeTab === 'history' }"
        >
          <i class="fas fa-history"></i> PNC Completion
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "PostnatalClinic",
  data() {
    return {
      activeTab: "mother",
      deliveryDate: "2023-12-01",
      postnatalDay: 7,
      mother: {
        id: "PN-2023-04567",
      },
      baby: {
        id: "BABY-2023-04567A",
      },
    };
  },
  methods: {
    editVisit() {
      // Edit visit logic
    },
    scheduleFollowup() {
      // Schedule follow-up logic
    },
  },
};
</script>

<style scoped>
#postnatal-app {
  padding: 20px;
  background-color: #f8f9fa;
}

.header {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  /* margin-bottom: 25px; */
  overflow: hidden;
}

.patient-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: linear-gradient(135deg, #4f6d9c 0%, #2c3e50 100%);
  color: white;
}

.patient-main-info h1 {
  font-size: 28px;
  font-weight: 600;
  /* margin-bottom: 15px; */
}

.patient-main-info h1 i {
  margin-right: 10px;
}

.patient-id-section {
  display: flex;
  gap: 20px;
  font-size: 16px;
  flex-wrap: wrap;
}

.patient-id-section span {
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
}

.action-buttons {
  display: flex;
  gap: 15px;
}

.action-buttons .btn {
  font-size: 16px;
  padding: 12px 24px;
  border-radius: 8px;
}

.navigation-tabs {
  display: flex;
  background: white;
  padding: 0;
  overflow-x: auto;
}

.nav-btn {
  flex: 1;
  min-width: 160px;
  padding: 18px 20px;
  border: none;
  border-bottom: 4px solid transparent;
  background: white;
  color: #6c757d;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.nav-btn:hover {
  background: #f8f9fe;
  color: #4f6d9c;
}

.nav-btn.active {
  color: #4f6d9c;
  border-bottom-color: #4f6d9c;
  background: #f8f9fe;
}

.nav-btn i {
  font-size: 18px;
}

.btn-primary {
  background: #4f6d9c;
  color: white;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary:hover {
  background: #3c567d;
}

.btn-success {
  background: #28a745;
  color: white;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.btn-success:hover {
  background: #218838;
}

/*  */
.nav-btn {
  text-decoration: none;
}
</style>
